import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "onChange", "defaultTypesText", "isLoading", "formControlProps", "groupFormControlsProps", "groupSelectProps", "renderTypeSelect", "renderGroupSelect", "hideIds", "userAccessibleGroups", "onGroupChange", "groups", "required", "canBeEmpty", "disableNonMarketingTypes", "withUserAccessibleGroups", "useGDPRFormattedTypes", "includeInternal"];
import { Fragment, useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { DEFAULT, getGroupOptions, getGroupAsOption, getTypeOptions, getGroupIdFromType, getTypeById } from '../utils/subscriptionSelectUtils';
import emptyFunction from 'react-utils/emptyFunction';
import withFetchedSubscriptionGroups from '../hoc/withFetchedSubscriptionGroups';
import { defaultRenderTypeSelect, defaultRenderGroupSelect } from './subscriptionTypeDefaultControls';
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubscriptionSelect = props => {
  const {
      value,
      onChange,
      defaultTypesText = '',
      isLoading,
      formControlProps = {},
      groupFormControlsProps = {},
      groupSelectProps = {},
      renderTypeSelect = defaultRenderTypeSelect,
      renderGroupSelect = defaultRenderGroupSelect,
      hideIds = [],
      userAccessibleGroups = [],
      onGroupChange: onGroupChangeProp = emptyFunction,
      groups = [],
      required = false,
      canBeEmpty = false,
      disableNonMarketingTypes = false,
      withUserAccessibleGroups = true,
      useGDPRFormattedTypes = true,
      includeInternal = true
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const initialValueRef = useRef(value);
  const [groupId, setGroupId] = useState(null);
  const [showPlaceholder, setShowPlaceholder] = useState(false);
  const onGroupChange = useCallback(id => {
    onGroupChangeProp({
      target: {
        value: id === DEFAULT ? null : id
      }
    });
    setGroupId(id);
  }, [onGroupChangeProp]);
  useEffect(() => {
    // Try to initialize selected group from selected type
    if (initialValueRef.current && groups.length) {
      const currentRefValue = Array.isArray(initialValueRef.current) ? initialValueRef.current[0] : initialValueRef.current;
      const typeGroupId = getGroupIdFromType(groups, currentRefValue);
      onGroupChange(typeGroupId);
    }
  }, [groups, initialValueRef, onGroupChange]);
  const groupOptions = useMemo(() => getGroupOptions(groups, withUserAccessibleGroups, userAccessibleGroups, defaultTypesText), [groups, withUserAccessibleGroups, userAccessibleGroups, defaultTypesText]);
  const groupOptionsIncludingCurrentValue = useMemo(() => {
    if (!groupId || groupId === DEFAULT || !withUserAccessibleGroups || typeof groupId === 'number' && userAccessibleGroups.includes(groupId)) {
      return groupOptions;
    }
    const filteredGroup = groups.find(g => g.preferencesGroup.id === groupId);
    const groupAsOption = filteredGroup ? getGroupAsOption(filteredGroup) : {};
    return [...groupOptions, groupAsOption];
  }, [groupOptions, withUserAccessibleGroups, userAccessibleGroups, groupId, groups]);
  const typeOptions = useMemo(() => getTypeOptions(groups, groupId, includeInternal, useGDPRFormattedTypes, hideIds, disableNonMarketingTypes), [groups, groupId, includeInternal, useGDPRFormattedTypes, disableNonMarketingTypes, hideIds]);
  const onSelectGroup = ({
    target
  }) => {
    setShowPlaceholder(true);
    onGroupChange(target.value);
    if (canBeEmpty) {
      onChange(null);
    }
  };
  const onChangeTypeId = ({
    target
  }) => {
    setShowPlaceholder(false);
    const type = getTypeById(groups, target.value);
    if (type || canBeEmpty) {
      onChange(type || null);
    }
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderGroupSelect(Object.assign({}, groupSelectProps, {
      isLoading,
      options: !isLoading && groupOptionsIncludingCurrentValue,
      value: groupId,
      onChange: onSelectGroup
    }), Object.assign({
      required
    }, groupFormControlsProps)), groupId && renderTypeSelect(Object.assign({}, otherProps, {
      options: !isLoading && typeOptions,
      value: showPlaceholder ? null : value,
      onChange: onChangeTypeId
    }), Object.assign({
      required
    }, formControlProps))]
  });
};
const SubscriptionTypeForm = withFetchedSubscriptionGroups(SubscriptionSelect);

// @ts-expect-error remove to see error
SubscriptionTypeForm.SubscriptionSelect = SubscriptionSelect;
export default SubscriptionTypeForm;